import React from 'react';
import { Helmet } from 'react-helmet';

const OrganizationSchema = () => {
  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://www.tensorpilot.io/#organization",
    "name": "TensorPilot",
    "url": "https://www.tensorpilot.io/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.tensorpilot.io/Logo.png", // Make sure this is the actual path to your logo
      "width": "512",
      "height": "512"
    },
    "sameAs": [
      "https://x.com/Tensor_Pilot", // Update these with your actual social media URLs
      "https://www.youtube.com/@tensor-pilot",
      "https://www.linkedin.com/company/tensor-pilot",
    ],
    "description": "Privacy-first desktop AI workspace with direct API access to leading providers. Your keys, your device, your data — available worldwide.",
    "foundingLocation": {
      "@type": "Place",
      "addressCountry": "CA",
      "name": "Canada"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Worldwide"
    },
    "knowsAbout": ["AI Privacy", "Private AI", "Desktop AI", "BYOK AI", "Data Sovereignty", "GDPR", "CCPA", "PIPEDA"],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "", // Update with your actual contact information
      "contactType": "customer service",
      "email": "support@tensorpilot.io", // Update with your actual contact email
      "availableLanguage": "English"
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Toronto",
      "addressRegion": "ON",
      "addressCountry": "Canada"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema;
